// Persistent app frame for all authenticated pages: the header stays fixed at
// the top while the routed page renders (and scrolls) in the area below it.

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import DesktopHeader from './DesktopHeader';

export default function AppLayout() {
  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default', overflow: 'hidden' }}>
      <DesktopHeader />
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Outlet />
      </Box>
    </Box>
  );
}
